{
  "el": {
    "lot": {
      "attributes": {
        "end_date": "Ημερομηνία λήξης",
        "internal_note": "Εσωτερική σημείωση οικοπέδου",
        "land_register": "Κτηματολόγιο",
        "name": "Όνομα",
        "start_date": "Ημερομηνία έναρξης",
        "surface": "Εμβαδόν"
      },
      "labels": {
        "lot": "Κανένα οικόπεδο | Ένα οικόπεδο | {count} οικόπεδα"
      },
      "toasts": {
        "create": "Το οικόπεδο δημιουργήθηκε",
        "delete": "Το οικόπεδο διαγράφηκε",
        "update": "Το οικόπεδο ενημερώθηκε"
      },
      "validation": {
        "needName": "Ο τίτλος είναι υποχρεωτικός",
        "needNumber": "Πρέπει να είναι αριθμός (π.χ. 85)"
      }
    }
  }
}
